import { LicenseAppPackageClient, LicenseMaster, LicenseMasterClient } from "@src/apis/ModularClient";

export class UserLicenseController {
  licenseMasterId: number = null;
  license: LicenseMaster = null;

  dataLoading: boolean = false;

  static $inject = ["$http", "$routeParams", "LicenseMasterClient"];

  constructor(
    private $http: ng.IHttpService,
    private $routeParams: ng.route.IRouteParamsService,
    private licenseMasterClient: LicenseMasterClient,
  ) {
    if (this.$routeParams.licensemasterid) {
      this.dataLoading = true;
      this.licenseMasterId = +this.$routeParams.licensemasterid;

      this.licenseMasterClient.fetch(this.$routeParams.licensemasterid).then((license: LicenseMaster) => {
        this.license = license;
      });
    }
  }
}
